export type ReferenceLike = { reference?: string | null };

function stripHistory(reference: string): string {
    const idx = reference.indexOf('/_history/');
    return idx >= 0 ? reference.slice(0, idx) : reference;
}

/**
 * Matches FHIR Reference strings robustly.
 *
 * Supports:
 * - Exact match: `ServiceRequest/123` === `ServiceRequest/123`
 * - Absolute vs relative: `https://.../ServiceRequest/123` endsWith `ServiceRequest/123`
 * - Versioned refs: `Observation/1/_history/2` matches `Observation/1`
 */
export function referenceMatches(reference: string | null | undefined, target: string | null | undefined): boolean {
    const ref = (reference || '').toString().trim();
    const tgt = (target || '').toString().trim();
    if (!ref || !tgt) return false;

    const refStripped = stripHistory(ref);
    if (refStripped === tgt) return true;
    return refStripped.endsWith(tgt);
}

export function referenceArrayContains(refs: Array<ReferenceLike> | null | undefined, target: string | null | undefined): boolean {
    if (!refs?.length) return false;
    return refs.some((r) => referenceMatches(r?.reference || undefined, target));
}
